import md5 from 'js-md5';
import async from 'async';

angular.module('WTG.INTERACT',['WTG.L','WTG.U']).factory('INTERACT',function(L,U,INTRACTABLE,$rootScope) {

 var EventHandler; /* manual hack for pseudo-circular injection */

 var itimeout = 15000; // a timeout for general interact operations
 var ltimeout = 60000; // a timeout for login request

 /** ****************************************************** **
  **  wtg_conversation                                      **
  ** ****************************************************** **/
 function wtg_conversation(id,data) {
  if(state.conversations[id]) L.error({id:id,data:data},"adding already existing conversation");
  state.conversations[id] = Object.assign( this, {
   id:id,
   p:[],        // participant ids
   lm:'',       // ?? last message?
   m:[],        // messages, [ {
                //  t: timestamp (Date)
                //  accid: seemingly, **destination** account id
                //  ch: channel id
                //  msg: message
                //  mid: message id
                // }, … ]
   msg_count: 0 // what count?
   // status
   // ts:
   // gid:      // queued for
   // flag_unreads: // has unread messages
   // timeline: {offset:number,retrieved:bool} // ?
  }, data||{} );
  $rootScope.$broadcast('wtg.conversations');
 }
 Object.assign(wtg_conversation.prototype,{
  update: function(data) {
   Object.assign(this,data);
   $rootScope.$broadcast('wtg.conversations');
   return this;
  },
  is_pending: function() {
   return this.status === D.conversation.status.pending;
  },
  is_ongoing: function() {
   return this.status === D.conversation.status.ongoing;
  },
  is_alive: function() {
   return this.status <= D.conversation.status.ongoing;
  },
  has_unreads: function() {
   return this.flag_unreads;
  },
  set_unreads: function(x) {
   this.flag_unreads = (x===undefined || x);
   return this;
  },
  reset_unreads: function() {
   this.flag_unreads = false;
   return this;
  },
  is_mine: function() {
   return state.myself && this.p.indexOf(state.myself.id)>=0;
  },
  add_message: function(m) {
   if(!m) return L.error({this:this,m:m},"refuse to add no message"),this;
   if(!(m.t instanceof Date)) return L.error({this:this,m:m},"message time is no time"),this;
   this.m.push(m);
   if(this.lm < m.t) this.lm = m.t;
   return this;
  },
  get_participants: function() {
   return this.p.map(function(p) {
    return INTERACT.get_account(p);
   });
  },
  add_participant: function(p) {
   var a = p.id ? p : (INTERACT.get_account(p)||INTERACT.add_account(p));
   if(this.p.indexOf(a.id)<0) this.p.push(a.id);
   // TODO: maybe delegate to wtg_account, but need to
   // be cautious to avoid infinite recursion
   if(a.c.indexOf(this.id)<0) a.c.push(this.id);
   return this;
  },
  remove_participant: function(p) {
   var that = this;
   var a = p.id ? p : INTERACT.get_account(p); // TODO: I assume it exists
   this.p = this.p.filter(function(x){return x!=a.id});
   // TODO: maybe delegate to wtg_account, but need to
   // watch out for infinite recursion
   a.c = a.c.filter(function(x){return x!=that.id});
   return this;
  },
  get_agents: function() {
   return this.get_participants().filter(function(x){return x.is_agent});
  },
  get_agent: function() {
   /* TODO: this is a dirtry trick, in case of me and agent I prefer myself for
    * an agent for the case of two-agents conversation. This may have
    * semi-desired effect on my conversations, but will not do much good to the
    * conversation I'm not a part of, but then there's no way yet to tell who
    * is the agent there */
   var pp = this.get_participants();
   return pp.find(function(x){return x.id==state.myself.id}) || pp.find(function(x){return x.is_agent});
  },
  get_agent_name: function() {
   var a = this.get_agent();
   if(a) return a.get_display_name();
   L.error({convo:this},"can't get agent name for the conversation");
   return undefined;
  },
  get_supportees: function() {
   return this.get_participants().filter(function(x){return !x.is_agent});
  },
  get_supportee: function() {
   var me, nonme;
   var pp = this.get_participants();
   for(var pi in pp) { var p = pp[pi];
    if(!p.is_agent) return p;
    if(p.id==state.myself.id) me = p;
    else nonme = p;
   }
   return me && nonme;
  },
  list_members: function() {
   INTERACT.killme.APILAYER.getListOfConversationMembers(this.id);
   return this;
  },
  select_queued: function() {
   INTERACT.killme.APILAYER.selectQueuedConversation({gid:this.gid,convid:this.id});
   return this;
  },
  request_status_change: function(status) {
   INTERACT.killme.APILAYER.changeSupportStatus({
    convid: this.id, status: status
   });
   return this;
  },
  helper: {     /* HELPER(S) */
   evaluate_admin_result: function eval_admin_result(cb,e,r) {
    if(e) return cb(e);
    switch(r.rc) {
     case 0: return cb();
     case 1: /* TODO: magic, no conversation, no rights */
      return cb(Object.assign(new Error("no rights or no conversation"),{rc:r.rc}));
     case 2: /* TODO: magic, operation failed */
      return cb(Object.assign(new Error("operation failed"),{rc:r.rc}));
    }
    cb(Object.assign(new Error("operation failed to even fail properly"),{rc:r.rc}));
   }
  },
  request_add_participant: function(p,cb) {
   L.trace({p:p.id||p,convid:this.id},"WIP: request_add_participant()");
   var that = this;
   U.ng.once$on({
    evt: 'wtg.interact.conversation.admin-result',
    trigger: function() {
     INTERACT.killme.APILAYER.addUserToTheConversation({
      convid: that.id,
      acid: p.id||p
     });
    },
    timeout: itimeout,
    assess: function(bc) { return bc.convid==that.id },
   }, this.helper.evaluate_admin_result.bind(this,function(e,r) {
    // XXX: hacky, but if the operation completed successfully we add
    // the participant…
    if(!e) that.add_participant(p);
    cb(e,r);
   }));
   return this;
  },
  request_remove_participant: function(p,cb) {
   var that = this;
   U.ng.once$on({
    evt: 'wtg.interact.conversation.admin-result',
    trigger: function() {
     INTERACT.killme.APILAYER.removeUserFromTheConversation({
      convid: that.id,
      acid: p.id||p
     });
    },
    timeout: itimeout,
    assess: function(bc) { return bc.convid==that.id },
   }, this.helper.evaluate_admin_result.bind(this,function(e,r) {
    // XXX: hacky, but if the operation completed successfully we remove
    // the participant…
    if(!e) that.remove_participant(p);
    cb(e,r);
   }));
   return this;
  },
  fetch: function wtg_conversation_fetch(cb) {
   /* TODO: deduplicate code with the fragment marked with 1557928541 */
   var convo = this;
   INTRACTABLE.request('conversation/list',{CID:convo.id,pandomain:true},function(e,r) {
    if(e) return cb && cb(e);
    if(r._S!='ok') return cb && cb(new Error('failed to load conversation'));
    if(!(r.conversations && r.conversations.length))
     return cb && cb(new Error('no conversation found'));
    if(r.conversations.length>1)
     return cb && cb(new Error('somehow found too many conversations?'));
    r.conversations.map(function(x) {
     x.ts = U.time.from_unix_epoch(x.ts);
     return x;
    }).forEach(function(c) {
     convo.update({status:c.status_id,ts:c.ts,title:c.title});
     c.p.forEach(function(p) {
      var pa = INTERACT.get_account(p.id)||INTERACT.add_account(p.id);
      pa.set_dn(p.name).update({
       fn: p.first_name, ln: p.last_name
      }).set_agentness(p.is_agent);
      convo.add_participant(pa);
     });
    });
    cb && cb(null,{convo});
   });
   return this;
  }
 });

 /** ****************************************************** **
  **  wtg_account                                           **
  ** ****************************************************** **/
 function wtg_account(id,data) {
  if(id===undefined) L.error({id,data},"trying to create an unidentfied flying account");
  if(state.accounts[id]) L.error({id:id,data:data},"adding already existing account");
  state.accounts[id] = Object.assign( this, {
   id: id,
   dn: '',              // display name
   c: [],               // conversation ids
   pr: undefined,       // profile {first_name:,last_name:,…}
   d: [],               // devices
   tr: {},              // ?
   ts: {},              // ?
   fn: '',              // first name
   ln: '',              // last name
   // sd:               // selected device **index**
   // dcid:
   // is_myself
  }, data||{} );
 }
 Object.assign(wtg_account.prototype,{
  update: function(data) {
   Object.assign(this,data);
   // TODO: make the following conditional
   $rootScope.$broadcast('wtg.conversations');
   return this;
  },
  set_dn: function(dn) {
   this.dn = dn;
   return this;
  },
  get_email: function() {
   return this.pr && this.pr.email;
  },
  get_mobile: function() {
   return this.pr && this.pr.mobile;
  },
  get_devices: function() {
   return this.d;
  },
  set_profile: function(pdata) {
   this.pr = pdata;
   return this;
  },
  /* get profile if available, if asynchronous callback is provided and there's
   * no profile available, load it. */
  get_profile: function(cb) {
   if(!cb) return this.pr;
   if(this.pr) return cb(null,this.pr);
   this.load_profile(cb);
  },
  load_profile: function(cb) {
   var that = this;
   INTRACTABLE.request('profile',{_AID:this.id,_V:1},function(e,r) {
    if(e) return cb(e);
    if(r._S!='ok') return cb(new Error("error fetching profile, _S:"+r._S));
    cb(null,that.set_profile(r.profile).get_profile());
   });
   return this;
  },
  get_conversations: function() {
   return this.c.map(function(cid) {
    return INTERACT.get_conversation(cid);
   });
  },
  load_conversations: function(cb) {
   INTRACTABLE.request("conversation/list",{_AID:this.id},(function(e,r) {
    if(e) return cb(e);
    if(r._S!='ok') return cb(new Error("failed to load conversations"));
    // TODO: deduplicate with very similar code in the event handler
    (r.conversations||[]).filter((c)=>(c.p.length>1)).map(function(x) {
     x.ts = U.time.from_unix_epoch(x.ts);
     return x;
    }).forEach(function(c) {
     var cid = +c.display_name;
     if(INTERACT.get_conversation(cid)) return;
     var convo = INTERACT.add_conversation(cid,{status:c.status_id,ts:c.ts,title:c.title});
     c.p.forEach(function(p) {
      var pa=INTERACT.get_account(p.id)||INTERACT.add_account(p.id);
      pa.set_dn(p.name).update({
       fn: p.first_name, ln: p.last_name
      }).set_agentness(p.is_agent);
      convo.add_participant(pa);
     });
    });
    cb(null,this.get_conversations());
   }).bind(this));
  },
  has_unreads: function() {
   return this.c && this.c.some(function(c) {
    var convo = INTERACT.get_conversation(c);
    if(!convo) return L.error({account:this},"account has inexistent conversations"),false;
    return convo.has_unreads();
   });
  },
  get_display_name: function() {
   // TODO: thi is quite ridiculous, but this is probably the most sensible way
   // to do it while there's no sign of order in there…
   return (this.pr && (this.pr.first_name||this.pr.last_name))||this.display_name||this.dn||this.fn||this.ln;
  },
  get_display_full_name: function() {
   // TODO: this is also quite ridiculous, but this is probably also the most
   // sensible way to do it for now.
   return (this.pr && (this.pr.first_name+' '+this.pr.last_name))||(this.fn && (this.fn+' '+this.ln))||this.display_name||this.dn||('OHNOTODO: '+this.id);
  },
  set_agentness: function(a) {
   this.is_agent = a;
   return this;
  },
  set_myself: function() {
   if(state.myself) {
    L.warn({oldself:state.myself,newself:this},"overriding myself, reassessing the life, universe and everything");
    delete state.myself.is_myself;
   }
   return (state.myself = this);
  },
  create_conversation(p,cb) {
   if(!p) p = {};
   var that = this;
   var chid = p.channelid||INTERACT.D.xaction.channel.chat;
   U.ng.once$on({
    evt: 'wtg.interact.create-conversation:'+chid,
    trigger: function() {
     INTERACT.killme.APILAYER.createConversation({
      acid: that.id,
      channelid: chid,
      convType: p.convtype||p.convType||1 /* TODO: magic, stands for support */
     });
    },
    timeout: itimeout,
    assess: function(bc) { return bc.acid==that.id },
   },function(e,r) {
    if(e) return cb(e);
    // XXX: a hack, but indeed if we create conversation we're probably a member.
    // maybe we should trigger a member retrieval here, though
    r.convo.add_participant(INTERACT.get_myself().id);
    // XXX: another hack, but as far as I can tell new conversations are created
    // with pending status. Whether it's a good idea is a different question,
    // but let's reflect it here
    r.convo.status = INTERACT.D.conversation.status.pending;
    if(cb) cb(null,r);
   });
   return this;
  },
  has_open_conversations: function() {
   return this.get_conversations().some(x=>x.is_alive());
  }
 });

 /** ****************************************************** **
  **  wtg_group                                             **
  ** ****************************************************** **/
 function wtg_group(id,data) {
  if(state.groups[id]) L.error({id:id,data:data},"adding already existing group");
  state.groups[id] = Object.assign( this, {
   id:id
   // name:
  }, data );
 }
 Object.assign(wtg_group.prototype,{
  list_conversations: function() {
   INTERACT.killme.APILAYER.getListofConversationsQueuedOnGroup({gid:this.id});
   return this;
  },
  get_conversations: function() {
   return INTERACT.get_conversations((function(c) {
    return c.gid==this.id;
   }).bind(this));
  }
 });

 var state = {
  conversations: {},    // {id:wtg_conversation} map
  accounts: {},         // {id:wtg_account} map
  groups: {},           // {id:wtg_group} map
  myself: undefined,    // wtg_account
  connection: {
   domain: undefined,
   actype: undefined,
   acname: undefined,
   acid: undefined,
   devid: undefined,
   token: undefined,
   sid: undefined,
   skey: undefined,
   password: undefined  // TODO: I don't like it
  }
 };
 var D = {
  conversation: {
   status: { pending: 0, ongoing: 1, interrupted: 4, closed: 5 },
   type: { support: 1, enduser: 2 }
  },
  xaction: {
   channel: {
    chat: 1, remote: 2,
    diagreq: 3,
    file_xfer: 4,
    backup: 5,
    diagres: 6,
    restore: 7,
    enqueueing: 8,
    relation: 9,
    videochat: 10
   },
   payload: {
    status: '6|status|',
    stop_status_flow: '6|status|STOP',
    status_acknowledgement: '6|status|OK'
   },
   result_evaluation: {
    skip:0, prog:1, ok:2, warn:3, prob:4,
    config_error:5, prereq_missing:6
   },
   live_diagnostics_states: {
    query:1, on:2, off:3
   }
  },
  client: {
   type: {
    web: 1,
    android:2,
    ios: 3,
    windows: 4,
    macos: 5
   }
  },
  virtual_connection: {
   type: { remote: 1, speedtest: 2, live_results: 3 },
   status: { create: 1, accept: 2, close: 3}
  },
  actype: {
   invalid: 0, unused: 0, not_used: 0,
   username: 1,
   email: 2,
   mobile: 3
  },
  register_device: {
   rc: {
    registered: 0,
    already: 1, already_registered: 1,
    unknown: 128, unknown_error: 128,
    duplicate: 129, duplicate_name: 129,
    invalid: 130, invalid_name: 130
   }
  },
  create_account: {
   status: {
    ok: 0, created: 0,
    unknown: 1, unknown_error: 1,
    bad_password: 2, invalid_password: 2,
    bad_name: 3, invalid_name: 3,
    already: 4, already_registered: 4,
    no_language: 5, no_suitable_language: 5
   }
  }
 };

 // { <state.connection content here> }
 $rootScope.$on('wtg.interact.login',function on_interact_login(evt,args) {
  // TODO: the whole `WTG.REPORT` should be represented by some injectable
  WTG.REPORT.user({username: args.acname,id: args.acid});
  WTG.REPORT.message('login','info');
  /* TODO: this is a bad hack to make sure INTRACTABLE already knows the token,
   * in the ideal flow it will be triggered from elsewhere */
  $rootScope.$evalAsync(function() {
   (INTERACT.get_account(args.acid)
    || INTERACT.add_account(args.acid)).set_dn(args.acname).set_myself().load_profile(function(e,r) {
    if(e) return L.error({err:e},"error loading profile");
    // TODO: I do not think it belongs here, but for now I have to keep it here
    $rootScope.profile = r;
   });
  });
 });
 // { status:,actype:,acname:[,acid:,sid:,skey:] }
 $rootScope.$on('wtg.interact.account.login',function on_interact_account_login(evt,args) {
  if(args.status) return;
  Object.assign(state.connection,{
   actype: args.actype,
   acname: args.acname,
   acid: args.acid
  });
  if(args.sid && args.skey) Object.assign(state.connection,{
   sid: args.sid, skey: args.skey
  });
  if(INTERACT.get_account(args.acid)) L.warn({args},"already know myself?");
  else INTERACT.add_account(args.acid).set_dn(args.acname).set_myself();
 });
 // { status:[,devid:,token:,sid:,skey:] }
 $rootScope.$on('wtg.interact.device.login',function on_interact_device_login(evt,args) {
  if(args.status) return;
  Object.assign(state.connection,{
   devid: args.devid,
   token: args.token
  });
  if(args.sid && args.skey) Object.assign(state.connection,{
   sid: args.sid, skey: args.skey
  });
 });
 // { convid:, status:, chid: [, acid:] }
 $rootScope.$on('wtg.interact.create-conversation',function on_interact_create_conversation(evt,args) {
  args.convo = INTERACT.add_conversation(args.convid,{
   ts: new Date()
  });
  if(args.acid) args.convo.add_participant(args.acid);
  $rootScope.$broadcast('wtg.interact.create-conversation:'+args.chid,args);
 });
 // { groups: [{id:,name:},…] }
 $rootScope.$on('wtg.interact.groups',function on_interact_groups(evt,args) {
  args.groups.forEach(function(g) {
   INTERACT.add_group(g.id,{name:g.name}).list_conversations();
  });
 });
 // { gid:, convinfo: [{convid:,ts:,status:},…], sort:?,order:?,limit:? }
 $rootScope.$on('wtg.interact.group.conversations',function on_interact_group_conversations(evt,args) {
  L.debug({args:args},"interact grouped conversations");
  args.convinfo.forEach(function(c) {
   const data = {
    gid: args.gid,
    ts: c.ts,
    status: c.status
   };
   (INTERACT.update_conversation(c.id,data)||INTERACT.add_conversation(c.id,data)).list_members();
   $rootScope.$broadcast('wtg.conversations');
  });
 });
 // { convid:, members: [{acid:,dn:?,nsessions:?},…] }
 $rootScope.$on('wtg.interact.conversation.members',function on_interact_conversation_members(evt,args) {
  var convo = INTERACT.get_conversation(+args.convid);
  if(!convo) L.error({args},"we were just about to append nothing to inexistent conversation");
  async.eachSeries(args.members,function(m,cb) {
   var ma = INTERACT.get_account(m.acid)||INTERACT.add_account(m.acid);
   if(m.dn) ma.set_dn(m.dn);
   convo.add_participant(ma);
   ma.get_profile(cb);
  },function(e) {
   if(e) return L.error({err:e},"had troubles processing conversation members");
  });
 });
 // {gid:,convid:,status:}
 $rootScope.$on('wtg.interact.group.conversation.change',function on_interact_conversation_change(evt,args) {
  var c = INTERACT.get_conversation(args.convid)||INTERACT.add_conversation(args.convid,{
   ts: new Date()
  }).list_members();
  switch(args.change) {
   case 'add':
    c.gid = args.gid;
    // TODO: doesn't belong here
    $rootScope.showToasterMsg('info',
     $rootScope.strings.str_new_ticket_notification_msg,
     $rootScope.strings.str_notification_header);
    c.status = INTERACT.D.conversation.status.pending;
    break;
   case 'remove':
    if(c.gid!=args.gid) L.warn({convo:c,args},"strangely we're about to remove ticket from the group it doesn't seem to belong to");
    delete c.gid;
    delete c.status; // TODO: this may be wrong, but how do I know what's the status now?
    c.fetch(function(e/*,r*/) {
     if(e) L.error({err:e},"error fetching conversation");
    });
    break;
   default:
    L.error({args:args},"unhandled group conversation change");
    break;
  }
  $rootScope.$broadcast('wtg.conversations');
 });
 // {change:join|leave|status,convid:,acid:,devid:,display_name:,support:,status:}
 $rootScope.$on('wtg.interact.conversation.change',function on_interact_conversation_change(evt,args) {
  var convo = INTERACT.get_conversation(args.convid);
  if(!convo) return L.warn({change:args},"change occurred to unknown conversation");
  switch(args.change) {
   case 'status':
    convo.update({status:args.status});
    break;
   case 'join':
    // TODO: special treatment for support members
    convo.add_participant(args.acid);
    $rootScope.$broadcast('wtg.conversations');
    break;
   case 'leave':
    convo.remove_participant(args.acid);
    $rootScope.$broadcast('wtg.conversations');
    break;
   default:
    L.warn({change:args},"unhandled change to conversation");
    break;
  }
 });

 var INTERACT = {
  D: D,
  state: state,

  get_conversations: function get_conversations(f) {
   var rv = Object.values(state.conversations);
   if(f) rv = rv.filter(f);
   return rv;
  },
  get_conversation: function get_conversation(input,cb) {
   if(!angular.isNumber(input)) {
    L.error({input:input},"Non-numeric input to INTERACT.get_conversation()");
    return cb && cb(new Error("unknown conversation"));
   }
   var rv = state.conversations[input];
   if(!cb) return rv;
   if(rv) return cb(null,rv);
   /* TODO: deduplicate code with the fragment marked with 1557928541 */
   INTRACTABLE.request('conversation/list',{CID:input},function(e,r) {
    if(e) return cb(e);
    if(r._S!='ok') return cb(new Error('failed to load conversation'));
    if(!(r.conversations && r.conversations.length))
     return cb(new Error('no conversation found'));
    if(r.conversations.length>1)
     L.warn({r:r,cid:input},"somehow found too many conversations?");
    r.conversations.map(function(x) {
     x.ts = U.time.from_unix_epoch(x.ts);
     return x;
    }).forEach(function(c) {
     var cid = +c.display_name;
     if(INTERACT.get_conversation(cid)) return;
      L.warn({cid:input},"already have conversation being loaded");
     var convo = INTERACT.add_conversation(cid,{status:c.status_id,ts:c.ts,title:c.title});
     c.p.forEach(function(p) {
      var pa=INTERACT.get_account(p.id)||INTERACT.add_account(p.id);
      pa.set_dn(p.name).update({
       fn: p.first_name, ln: p.last_name
      }).set_agentness(p.is_agent);
      convo.add_participant(pa);
     });
    });
    cb(null,INTERACT.get_conversation(input));
   });
  },
  add_conversation: function add_conversation(id,data) {
   return new wtg_conversation(id,data);
  },
  update_conversation: function update_conversation(c,data) {
   var convo = angular.isNumber(c) ? this.get_conversation(c) : c;
   if(convo) convo.update(data);
   return convo;
  },

  get_account: function get_account(acid) {
   return state.accounts[acid];
  },
  add_account: function add_account(id,data) {
   return new wtg_account(id,data);
  },
  get_myself: function() {
   return state.myself;
  },

  add_group: function add_group(id,data) {
   return new wtg_group(id,data);
  },
  get_group: function get_group(gid) {
   return state.groups[gid];
  },

  is_logged_in: function() {
   return !!state.connection.token;
  },

  // {domain:,location:,host:,port:}
  connect: function interact_connect(pp,cb) {
   // TODO: by no means below looks beautiful
   var h,p;
   if(pp.host && pp.port) {
    h = pp.host, p = pp.port;
   }else{
    var loc = pp.location||window.location;
    h = loc.origin.split(':').splice(0,2).join(':');
    p = +loc.port;
   }
   U.ng.once$on({
    evt: 'wtg.interact.connected',
    trigger: function() {
     INTERACT.killme.APILAYER.init(h,p,
      Object.assign({},EventHandler.killme.apilayer_callbacks),
      pp.domain);
    },
    timeout: itimeout
   },function(e,r) {
    if(!e) $rootScope.$broadcast('wtg.interact.connect',{
     domain: (INTERACT.state.connection.domain = pp.domain)
    });
    cb(e,r);
   });
  },

  // input: {payload:[,timeout:]}
  // output: {payload:}
  ping: function interact_ping(pp,cb) {
   if(!cb) cb=pp, pp={};
   else pp = pp||{};
   var payload = pp.payload||(''+ +new Date()).split('').map(function(x){return +x});
   U.ng.once$on({
    evt: 'wtg.interact.pong',
    trigger: function() {
     INTERACT.killme.APILAYER.pingServer(payload);
    },
    assess: function(args) {
     var pl = args.payload;
     return angular.isArray(pl) && payload.length==pl.length  &&
      pl.every(function(v,i) { return v===payload[i] });
    },
    timeout: pp.timeout||itimeout,
   },cb||angular.noop);
  },

  // {actype:,acname|username|email|mobile:,password:}
  // {devid:,token:,acid:,actype:,acname:}
  login: function interact_login(pp,cb) {
   if(pp.hasOwnProperty('password')) return this.login_password(pp,cb);
   else if(pp.devid && pp.token) return this.login_token(pp,cb);
   L.error({pp},"don't know how to login");
   cb(new Error("don't know how to login"));
  },
  // {actype:,acname|username|email|mobile:,password:}
  // returns: {status:,actype:,acname:[,acid:,sid:,skey:]}
  login_password: function interact_login_password(pp,cb) {
   var l;
   if(pp.actype!==undefined) l = {actype:pp.actype,acname:pp.acname||pp.username||pp.email||pp.mobile};
   else if(pp.mobile) l = {actype:INTERACT.D.actype.mobile,mobile:pp.mobile};
   else if(pp.email) l = {actype:INTERACT.D.actype.email,email:pp.email};
   else if(pp.username) l = {actype:INTERACT.D.actype.username,username:pp.username};
   else if(U.is_valid_mobile(pp.acname)) l = {actype:INTERACT.D.actype.mobile,acname:pp.acname};
   else if(U.is_valid_email(pp.acname)) l = {actype:INTERACT.D.actype.email,acname:pp.acname};
   else if(pp.acname) l = {actype:INTERACT.D.actype.username,acname:pp.acname};
   else return L.error({pp},"can't tell how to login"),cb(new Error("can't tell how to login"));
   l.password = pp.password;
   U.ng.once$on({
    evt: 'wtg.interact.account.login',
    trigger: function() {
     INTERACT.killme.APILAYER.attemptLogin(l);
    },
    timeout: ltimeout
   },function(e,r) { /* {status:,actype:,acname:,acid:,sid:,skey:} */
    if(e) return cb(e);
    if(r.status) return cb(new Error("login failure"),r);
    L.trace({r},"logged in, it seems");
    Object.assign(state.connection,{
     /* TODO: I am not excited about the password, because we're likely not to
      * have it for most of the sessions and it's generally not the thing to
      * have around, but we do seem to use it in tab-diagnostics */
     password: pp.password
    });
    cb(null,r);
   });
   return this;
  },
  // {devid:,token:,actype:,acname:,acid:}
  // returns: {status:[,devid:,token:,sid:,skey:]}
  login_token: function interact_login_token(pp,cb) {
   U.ng.once$on({
    evt: 'wtg.interact.device.login',
    trigger: function() {
     INTERACT.killme.APILAYER.attemptTokenLogin(pp);
    },
    timeout: itimeout
   },function(e,r) { /* {status:,devid:,token:,sid:,skey:} */
    if(e) return cb(e);
    if(r.status) return cb(new Error("token login failure"),r);
    L.trace({r},"logged in device, it seems");
    Object.assign(state.connection,{
     actype: pp.actype, acname: pp.acname,
     acid: pp.acid
    });
    $rootScope.$broadcast('wtg.interact.login',state.connection);
    cb(null,r);
   });
   return this;
  },
  // {name:[,type:][,model:][,imei:][,display_name:][,productid:]}
  // returns: {devname:,model:,imei:,display_name:,rc:,devid:,token:}
  register_device: function interact_register_devie(pp,cb) {
   U.ng.once$on({
    evt: 'wtg.interact.device.register',
    trigger: function() {
     INTERACT.killme.APILAYER.registerADevice(pp);
    },
    timeout:itimeout
    // TODO: possibly, assess
   },function(e,r) {
    if(e) return cb(e);
    switch(r.rc) {
     case INTERACT.D.register_device.rc.registered:
     case INTERACT.D.register_device.rc.already:
      break;
     case INTERACT.D.register_device.rc.unknown:
      return cb(new Error('unkown error while registering a device'),r);
     case INTERACT.D.register_device.rc.duplicate:
      return cb(new Error('duplicate device while registering a device'),r);
     case INTERACT.D.register_device.rc.invalid:
      return cb(new Error('invalid device name while registering a device'),r);
     default:
      return cb(new Error('very unknown error while registering a device'),r);
    }
    L.trace({r},"registered a device, apparently");
    Object.assign(state.connection,{
     devid: r.devid,
     token: r.token
    });
    $rootScope.$broadcast('wtg.interact.login',state.connection);
    cb(null,r);
   });
   return this;
  },
  // {acname:,password:}
  // returns: {status:,actype:,acname:,acid:,sid:,skey:}
  create_account: function interact_create_account(pp,cb) {
   U.ng.once$on({
    evt: 'wtg.interact.account.create',
    trigger: function() {
     EventHandler.APILAYER.createAccount( /* TODO: rework on the APILAYER side */
      pp.acname, pp.password,
      U.is_valid_email(pp.acname)?pp.acname:"",
      U.is_valid_mobile(pp.acname)?pp.acname:""
     );
    },
    timeout:itimeout
    // TODO: possibly, assess
   },function(e,r) {
    if(e) return cb(e);
    switch(r.status) {
     case INTERACT.D.create_account.status.ok:
      break;
     case INTERACT.D.create_account.status.unknown:
      return cb(new Error('unknown error while creating an account'));
     case INTERACT.D.create_account.status.bad_password:
      return cb(new Error('invalid password while creating an account'));
     case INTERACT.D.create_account.status.bad_name:
      return cb(new Error('invalid name while creating an account'));
     case INTERACT.D.create_account.status.already:
      return cb(new Error('account already registered'));
     case INTERACT.D.create_account.status.no_language:
      return cb(new Error('no suitable language found'));
     default:
      return cb(new Error('utterly unknown error while creating an account'));
    }
    L.trace({r},"apparently, created an account");
    Object.assign(state.connection,{
     acid: r.acid,
     actype: r.actype, acname: r.acname,
     sid: r.sid, skey: r.skey,
     password: pp.password
    });
    cb(null,r);
   });
   return this;
  },

  killme: { /* The _temporary_ wrapper around libwtgserver goes here */
   APILAYER: undefined,
   inject_EventHandler: function inject_EventHandler(eh) {
    EventHandler = eh;
    this.APILAYER = eh.APILAYER;
   }
  },

  U: {
   // {domain:Number|String,username:,password:}
   login: function(pp,cb) {
    async.auto({
     domain: function U_login_domain(cb) {
      if(angular.isNumber(pp.domain)) return cb(null,pp.domain);
      INTRACTABLE.request("domain/lookup", { name:pp.domain }, function(e,r) {
       if(e) return cb(e);
       if(r._S!='ok') return L.error({r:r},"error looking up domain"),
       cb(Object.assign(new Error("error looking up domain"),{api:"domain",r:r}));
       cb(null,r.domain);
      });
     },
    connect: ['domain',function U_login_connect(r,cb) {
     INTERACT.connect({domain:r.domain},cb);
    }],
    login: ['connect',function U_login_login(r,cb) {
     INTERACT.login({username:pp.username,password:pp.password},cb);
    }],
    device: ['login',function U_login__device(r,cb) {
     /* TODO: deduplicate similar code in register controller 1563031054 */
     INTERACT.register_device({
      name: md5(navigator.userAgent),
      type: INTERACT.D.client.typeweb
     },cb);
    }]
    },function(e,r) {
     $rootScope.$applyAsync(cb.bind(null,e,r));
    });
   }
  }

 };
 return INTERACT;
});
/* vim:set ts=8 sw=1 expandtab: */
